unit UWebBarcodeScanner;

interface

uses
  JS, WebLib.Devices, WebLib.ExtCtrls;

const
  SOUND = '//uQRAAAAWMSLwUIYAAsYkXgoQwAEaYLWfkWgAI0wWs/ItAAAGDgYtAgAyN+QWaAAihwM'+
          'Wm4G8QQRDiMcCBcH3Cc+CDv/7xA4Tvh9Rz/y8QADBwMWgQAZG/ILNAARQ4GLTcDeIIIhx'+
          'GOBAuD7hOfBB3/94gcJ3w+o5/5eIAIAAAVwWgQAVQ2ORaIQwEMAJiDg95G4nQL7mQVWI6'+
          'GwRcfsZAcsKkJvxgxEjzFUgfHoSQ9Qq7KNwqHwuB13MA4a1q/DmBrHgPcmjiGoh//EwC5'+
          'nGPEmS4RcfkVKOhJf+WOgoxJclFz3kgn//dBA+ya1GhurNn8zb//9NNutNuhz31f////9'+
          'vt///z+IdAEAAAK4LQIAKobHItEIYCGAExBwe8jcToF9zIKrEdDYIuP2MgOWFSE34wYiR'+
          '5iqQPj0JIeoVdlG4VD4XA67mAcNa1fhzA1jwHuTRxDUQ//iYBczjHiTJcIuPyKlHQkv/L'+
          'HQUYkuSi57yQT//uggfZNajQ3Vmz+Zt//+mm3Wm3Q576v////+32///5/EOgAAADVghQA'+
          'AAAA//uQZAUAB1WI0PZugAAAAAoQwAAAEk3nRd2qAAAAACiDgAAAAAAABCqEEQRLCgwpB'+
          'GMlJkIz8jKhGvj4k6jzRnqasNKIeoh5gI7BJaC1A1AoNBjJgbyApVS4IDlZgDU5WUAxEK'+
          'DNmmALHzZp0Fkz1FMTmGFl1FMEyodIavcCAUHDWrKAIA4aa2oCgILEBupZgHvAhEBcZ6j'+
          'oQBxS76AgccrFlczBvKLC0QI2cBoCFvfTDAo7eoOQInqDPBtvrDEZBNYN5xwNwxQRfw8Z'+
          'Q5wQVLvO8OYU+mHvFLlDh05Mdg7BT6YrRPpCBznMB2r//xKJjyyOh+cImr2/4doscwD6n'+
          'eZjuZR4AgAABYAAAABy1xcdQtxYBYYZdifkUDgzzXaXn98Z0oi9ILU5mBjFANmRwlVJ3/'+
          '6jYDAmxaiDG3/6xjQQCCKkRb/6kg/wW+kSJ5//rLobkLSiKmqP/0ikJuDaSaSf/6JiLYL'+
          'EYnW/+kXg1WRVJL/9EmQ1YZIsv/6Qzwy5qk7/+tEU0nkls3/zIUMPKNX/6yZLf+kFgAfg'+
          'GyLFAUwY//uQZAUABcd5UiNPVXAAAApAAAAAE0VZQKw9ISAAACgAAAAAVQIygIElVrFkB'+
          'S+Jhi+EAuu+lKAkYUEIsmEAEoMeDmCETMvfSHTGkF5RWH7kz/ESHWPAq/kcCRhqBtMdok'+
          'PdM7vil7RG98A2sc7zO6ZvTdM7pmOUAZTnJW+NXxqmd41dqJ6mLTXxrPpnV8avaIf5SvL'+
          '7pndPvPpndJR9Kuu8fePvuiuhorgWjp7Mf/PRjxcFCPDkW31srioCExivv9lcwKEaHsf/'+
          '7ow2Fl1T/9RkXgEhYElAoCLFtMArxwivDJJ+bR1HTKJdlEoTELCIqgEwVGSQ+hIm0NbK8'+
          'WXcTEI0UPoa2NbG4y2K00JEWbZavJXkYaqo9CRHS55FcZTjKEk3NKoCYUnSQ0rWxrZbFK'+
          'bKIhOKPZe1cJKzZSaQrIyULHDZmV5K4xySsDRKWOruanGtjLJXFEmwaIbDLX0hIPBUQPV'+
          'FVkQkDoUNfSoDgQGKPekoxeGzA4DUvnn4bxzcZrtJyipKfPNy5w+9lnXwgqsiyHNeSVpe'+
          'mw4bWb9psYeq//uQZBoABQt4yMVxYAIAAAkQoAAAHvYpL5m6AAgAACXDAAAAD59jblTir'+
          'Qe9upFsmZbpMudy7Lz1X1DYsxOOSWpfPqNX2WqktK0DMvuGwlbNj44TleLPQ+Gsfb+GOW'+
          'OKJoIrWb3cIMeeON6lz2umTqMXV8Mj30yWPpjoSa9ujK8SyeJP5y5mOW1D6hvLepeveEA'+
          'EDo0mgCRClOEgANv3B9a6fikgUSu/DmAMATrGx7nng5p5iimPNZsfQLYB2sDLIkzRKZOH'+
          'GAaUyDcpFBSLG9MCQALgAIgQs2YunOszLSAyQYPVC2YdGGeHD2dTdJk1pAHGAWDjnkcLK'+
          'FymS3RQZTInzySoBwMG0QueC3gMsCEYxUqlrcxK6k1LQQcsmyYeQPdC2YfuGPASCBkcVM'+
          'QQqpVJshui1tkXQJQV0OXGAZMXSOEEBRirXbVRQW7ugq7IM7rPWSZyDlM3IuNEkxzCOJ0'+
          'ny2ThNkyRai1b6ev//3dzNGzNb//4uAvHT5sURcZCFcuKLhOFs8mLAAEAt4UWAAIABAAA'+
          'AAB4qbHo0tIjVkUU//uQZAwABfSFz3ZqQAAAAAngwAAAE1HjMp2qAAAAACZDgAAAD5UkT'+
          'E1UgZEUExqYynN1qZvqIOREEFmBcJQkwdxiFtw0qEOkGYfRDifBui9MQg4QAHAqWtAWHo'+
          'Cxu1Yf4VfWLPIM2mHDFsbQEVGwyqQoQcwnfHeIkNt9YnkiaS1oizycqJrx4KOQjahZxWb'+
          'cZgztj2c49nKmkId44S71j0c8eV9yDK6uPRzx5X18eDvjvQ6yKo9ZSS6l//8elePK/Lf/'+
          '/IInrOF/FvDoADYAGBMGb7FtErm5MXMlmPAJQVgWta7Zx2go+8xJ0UiCb8LHHdftWyLJE'+
          '0QIAIsI+UbXu67dZMjmgDGCGl1H+vpF4NSDckSIkk7Vd+sxEhBQMRU8j/12UIRhzSaUdQ'+
          '+rQU5kGeFxm+hb1oh6pWWmv3uvmReDl0UnvtapVaIzo1jZbf/pD6ElLqSX+rUmOQNpJFa'+
          '/r+sa4e/pBlAABoAAAAA3CUgShLdGIxsY7AUABPRrgCABdDuQ5GC7DqPQCgbbJUAoRSUj'+
          '+NIEig0YfyWUho1VBBBA//uQZB4ABZx5zfMakeAAAAmwAAAAF5F3P0w9GtAAACfAAAAAw'+
          'LhMDmAYWMgVEG1U0FIGCBgXBXAtfMH10000EEEEEECUBYln03TTTdNBDZopopYvrTTdNa'+
          '325mImNg3TTPV9q3pmY0xoO6bv3r00y+IDGid/9aaaZTGMuj9mpu9Mpio1dXrr5HERTZS'+
          'mqU36A3CumzN/9Robv/Xx4v9ijkSRSNLQhAWumap82WRSBUqXStV/YcS+XVLnSS+WLDro'+
          'qArFkMEsAS+eWmrUzrO0oEmE40RlMZ5+ODIkAyKAGUwZ3mVKmcamcJnMW26MRPgUw6j+L'+
          'khyHGVGYjSUUKNpuJUQoOIAyDvEyG8S5yfK6dhZc0Tx1KI/gviKL6qvvFs1+bWtaz58uU'+
          'Nnryq6kt5RzOCkPWlVqVX2a/EEBUdU1KrXLf40GoiiFXK///qpoiDXrOgqDR38JB0bw7S'+
          'oL+ZB9o1RCkQjQ2CBYZKd/+VJxZRRZlqSkKiws0WFxUyCwsKiMy7hUVFhIaCrNQsKkTIs'+
          'LivwKKigsj8XYlwt/WKi2N4d//uQRCSAAjURNIHpMZBGYiaQPSYyAAABLAAAAAAAACWAA'+
          'AAApUF/Mg+0aohSIRobBAsMlO//Kk4soosy1JSFRYWaLC4qZBYWFRGZdwqKiwkNBVmoWF'+
          'SJkWFxX4FFRQWR+LsS4W/rFRb////////////////////////////////////////////'+
          '/////////////////////////////////////////////////////////////////////'+
          '/////////////////////////////////////////////////////////////////////'+
          '/////////////////////////////////////////////////////////////////////'+
          '/////////////////////////////////////////////////////////////////////'+
          '/////////////////////////////////////////////////////////////////////'+
          '////////////////////////////VEFHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
          'AAAU291bmRib3kuZGUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA'+
          'AAAAAAAAAAAAAAMjAwNGh0dHA6Ly93d3cuc291bmRib3kuZGUAAAAAAAAAACU=';

type
  TBarcodeType = (btAztec, btCode_128, btCode_39, btCode_93, btCodabar,
    btData_Matrix, btEan_13, btEan_8, btItf, btPdf417, btQr_Code, btUpc_A,
    btUpc_E, btUnknown);

  TBarcodeTypes = set of TBarcodeType;

  TBarcodeDetectEvent = procedure(Sender: TObject; ACode: string) of object;
  TBarcodeSupportEvent = procedure(Sender: TObject; IsSupported: Boolean)
    of object;
  TBarcodeSupportedFormatsEvent = procedure(Sender: TObject;
    AType: TBarcodeType) of object;
  TBarcodeErrorEvent = procedure(Sender: TObject; AMsg: string) of object;

  TBarcodeScanner = class
  private
    FOnDetect: TBarcodeDetectEvent;
    FOnSupported: TBarcodeSupportEvent;
    FOnSupportedFormats: TBarcodeSupportedFormatsEvent;
    FOnError: TBarcodeErrorEvent;
    FDevice: TCamera;
    FIntervall: Integer;
    FTimer: TTimer;
    FAcceptedBarcodeTypes: TBarcodeTypes;
    FBeepOnDetect: Boolean;
    procedure Activate(ImageData: string);
    procedure Beep;
    procedure DoHandleDetect(ACode: string);
    procedure DoHandleError(AMsg: string);
    procedure DoHandleSupported(IsSupported: Boolean);
    procedure DoHandleSupportedFormats(Format: string);
    procedure TimerOnTime(Sender: TObject);
    procedure SetOnSupported(const Value: TBarcodeSupportEvent);
    procedure SetOnSupportedFormats(const Value: TBarcodeSupportedFormatsEvent);
    procedure SetOnError(const Value: TBarcodeErrorEvent);
    procedure SetDevice(const Value: TCamera);
    procedure SetIntervall(const Value: Integer);
    procedure SetAcceptedBarcodeTypes(const Value: TBarcodeTypes);
    procedure SetBeepOnDetect(const Value: Boolean);
  public
    class function BarcodeTypeToStr(Value: TBarcodeType;
      InLowerCase: Boolean = false): string;
    class function StrToBarcodeType(Value: string): TBarcodeType;
    constructor Create(Camera: TCamera);
    function Active: Boolean;
    procedure IsSupported;
    procedure Start;
    procedure Stop;
    procedure SupportedFormats;
    property OnDetect: TBarcodeDetectEvent read FOnDetect write FOnDetect;
    property OnSupported: TBarcodeSupportEvent read FOnSupported
      write SetOnSupported;
    property OnSupportedFormats: TBarcodeSupportedFormatsEvent
      read FOnSupportedFormats write SetOnSupportedFormats;
    property OnError: TBarcodeErrorEvent read FOnError write SetOnError;
    property Device: TCamera read FDevice write SetDevice;
    property Intervall: Integer read FIntervall write SetIntervall;
    property AcceptedBarcodeTypes: TBarcodeTypes read FAcceptedBarcodeTypes
      write SetAcceptedBarcodeTypes;
    property BeepOnDetect: Boolean read FBeepOnDetect write SetBeepOnDetect;
  end;

implementation

uses
  System.SysUtils;

{ TWebBarcodeScanner }

procedure TBarcodeScanner.Activate(ImageData: string);
var
  bt: TBarcodeType;
  i: Integer;
  bcta: array of string;
begin
  i := 0;
  for bt := Low(TBarcodeType) to High(TBarcodeType) do
    if bt in Self.AcceptedBarcodeTypes then begin
      Inc(i);
      SetLength(bcta, i);
      bcta[i - 1] := TBarcodeScanner.BarcodeTypeToStr(bt, true);
    end;
  asm
    async function scanCode(aScanner, data, barcodetypes) {
      const barcodeDetector = new BarcodeDetector({
        formats: barcodetypes,
      });
      const img = new Image();
      await loadImage(ImageData, img);
      barcodeDetector
        .detect(img)
        .then((barcodes) => {
          barcodes.forEach((barcode) => aScanner.DoHandleDetect(barcode.rawValue));
        })
      .catch((err) => {
        aScanner.DoHandleError(err);
      });
    }
    async function loadImage(url, elem) {
      return new Promise((resolve, reject) => {
        elem.onload = () => resolve(elem);
        elem.onerror = reject;
        elem.src = url;
      });
    }
    scanCode(this, ImageData, bcta);
  end;
end;

function TBarcodeScanner.Active: Boolean;
begin
  Result := Self.FTimer.Enabled;
end;

class function TBarcodeScanner.BarcodeTypeToStr(Value: TBarcodeType;
  InLowerCase: Boolean = false): string;
begin
  case Value of
    btUnknown:
      Result := 'unbekannt';
    btAztec:
      Result := 'AZTEC';
    btCode_128:
      Result := 'CODE_128';
    btCode_39:
      Result := 'CODE_39';
    btCode_93:
      Result := 'CODE_93';
    btCodabar:
      Result := 'CODABAR';
    btData_Matrix:
      Result := 'DATA_MATRIX';
    btEan_13:
      Result := 'EAN_13';
    btEan_8:
      Result := 'EAN_8';
    btItf:
      Result := 'ITF';
    btPdf417:
      Result := 'PDF417';
    btQr_Code:
      Result := 'QR_CODE';
    btUpc_A:
      Result := 'UPC_A';
    btUpc_E:
      Result := 'UPC_E';
  end;
  if InLowerCase then
    Result := LowerCase(Result);
end;

procedure TBarcodeScanner.Beep;
var
  s: string;
begin
  s:='data:audio/wav;base64,' + SOUND;
  asm
    function beep(data) {
      var snd = new Audio(data);
      snd.play();
    };
    beep(s);
  end;
end;

constructor TBarcodeScanner.Create(Camera: TCamera);
begin
  Self.Device := Camera;
  Self.FTimer := TTimer.Create(nil);
  Self.FTimer.Enabled := False;
  Self.FTimer.OnTimer := Self.TimerOnTime;
  Self.Intervall := 500;
  Self.BeepOnDetect := true;
end;

procedure TBarcodeScanner.DoHandleDetect(ACode: string);
begin
  if Self.BeepOnDetect then
    Self.Beep;
  if Assigned(Self.OnDetect) then
    Self.OnDetect(Self, ACode);
end;

procedure TBarcodeScanner.DoHandleError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TBarcodeScanner.DoHandleSupported(IsSupported: Boolean);
begin
  if Assigned(Self.OnSupported) then
    Self.OnSupported(Self, IsSupported);
end;

procedure TBarcodeScanner.DoHandleSupportedFormats(Format: string);
begin
  Self.AcceptedBarcodeTypes := [];
  Self.AcceptedBarcodeTypes := Self.AcceptedBarcodeTypes +
    [TBarcodeScanner.StrToBarcodeType(Format)];
  if Assigned(Self.OnSupportedFormats) then
    Self.OnSupportedFormats(Self, TBarcodeScanner.StrToBarcodeType(Format));
end;


procedure TBarcodeScanner.IsSupported;
begin
  asm
    async function support(aScanner) {
      if ("BarcodeDetector" in globalThis) {
        aScanner.DoHandleSupported(true);
      }
      else {
        aScanner.DoHandleSupported(false);
      }
    }
    support(this);
  end;
end;

procedure TBarcodeScanner.SetAcceptedBarcodeTypes(
  const Value: TBarcodeTypes);
begin
  FAcceptedBarcodeTypes := Value;
end;

procedure TBarcodeScanner.SetBeepOnDetect(const Value: Boolean);
begin
  FBeepOnDetect := Value;
end;

procedure TBarcodeScanner.SetDevice(const Value: TCamera);
begin
  FDevice := Value;
end;

procedure TBarcodeScanner.SetIntervall(const Value: Integer);
begin
  FIntervall := Value;
  FTimer.Interval := Value;
end;

procedure TBarcodeScanner.SetOnError(const Value: TBarcodeErrorEvent);
begin
  FOnError := Value;
end;

procedure TBarcodeScanner.SetOnSupported(const Value: TBarcodeSupportEvent);
begin
  FOnSupported := Value;
end;

procedure TBarcodeScanner.SetOnSupportedFormats(
  const Value: TBarcodeSupportedFormatsEvent);
begin
  FOnSupportedFormats := Value;
end;

procedure TBarcodeScanner.Start;
begin
  if Self.Device <> nil then
  begin
    Self.Device.Start;
    Self.FTimer.Enabled := true;
  end;
end;

procedure TBarcodeScanner.Stop;
begin
  if Self.Device <> nil then
  begin
    Self.Device.Stop;
    Self.FTimer.Enabled := false;
  end;
end;

class function TBarcodeScanner.StrToBarcodeType(Value: string): TBarcodeType;
begin
  Value := UpperCase(Value);
  if Value = 'AZTEC' then
    Result := btAztec
  else if Value = 'CODE_128' then
    Result := btCode_128
  else if Value = 'CODE_39' then
    Result := btCode_39
  else if Value = 'CODE_93' then
    Result := btCode_93
  else if Value = 'CODABAR' then
    Result := btCodabar
  else if Value = 'DATA_MATRIX' then
    Result := btData_Matrix
  else if Value = 'EAN_13' then
    Result := btEan_13
  else if Value = 'EAN_8' then
    Result := btEan_8
  else if Value = 'ITF' then
    Result := btItf
  else if Value = 'PDF417' then
    Result := btPdf417
  else if Value = 'QR_CODE' then
    Result := btQr_Code
  else if Value = 'UPC_A' then
    Result := btUpc_A
  else if Value = 'UPC_E' then
    Result := btUpc_E
  else
    Result := btUnknown;
end;

procedure TBarcodeScanner.SupportedFormats;
begin
  asm
    function supForm(aScanner) {
      BarcodeDetector.getSupportedFormats().then((supportedFormats) => {
        supportedFormats.forEach((format) => aScanner.DoHandleSupportedFormats(format));
      });
    }
    supForm(this);
  end;
end;

procedure TBarcodeScanner.TimerOnTime(Sender: TObject);
begin
  if Self.Device <> nil then
    Self.Activate(Self.Device.SnapShotAsBase64)
  else
    Self.Stop;
end;

end.
